import React from 'react';
import { CircularProgress } from '@mui/material';
import { useStyles } from './loader.styles';

export const Loader = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.loaderBlock}>
      <CircularProgress disableShrink />
    </div>
  );
};
